import { IPercentageSplit } from '../../../entities/offsiteCampaign';

export const UpdatedSplitTestPercentages = (splits: IPercentageSplit[]) => {
  const newPercentageValue = Math.floor(100 / splits.length);

  const updatedSplits = splits.map(
    split =>
      ({
        id: split.id,
        percentage: newPercentageValue,
        cycles: split.cycles,
        name: split.name,
      } as IPercentageSplit),
  );

  const checkPercentage = splits.length * newPercentageValue;
  if (checkPercentage !== 100) {
    const remaining = 100 - checkPercentage;
    for (let i = 1; i <= remaining; i++) {
      updatedSplits[i - 1].percentage = newPercentageValue + 1;
    }
  }
  return updatedSplits;
};
